import script from "./MyDatePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyDatePicker.vue?vue&type=script&setup=true&lang=ts"

import "./MyDatePicker.vue?vue&type=style&index=0&id=bd2fa898&lang=scss"

const __exports__ = script;

export default __exports__